import { get } from "./helpers/helperFunctions";

window.getSessionID = () => {
  return parseInt(window.location.pathname.split("/u/")[1] || 0, 10);
};

window.getAuth = () => {
  let auth = get("main-auth") || {};
  return auth;
};
